import {
    ArrayField, ChipField,
    Datagrid,
    DateField,
    List,
    ReferenceInput,
    SelectInput,
    SingleFieldList,
    TextField,
    TextInput
} from "react-admin";
import { StatusField } from "../../components/forms/status-field";

const FormsRequestList = (props) => {
    const filters = [
        <TextInput source={'user'} label={'Solicitante'} alwaysOn />,
        <SelectInput
            label="Status"
            source="status"
            choices={[
                { name: "Pendente", id: "opened" },
                { name: "Deferido", id: "approved" },
                { name: "Indeferido", id: "rejected" },
                { name: "Todos", id: "" },
            ]}
            alwaysOn
        />,
        <ReferenceInput
            source="formId"
            reference="forms"
            perPage={9999}
            label={'Formulário'}
            alwaysOn
            style={{ width: '400px' }}
            filter={{ academic_period: 'current' }}
        >
            <SelectInput emptyText={'Todos'} source="name" optionText={record => record.name} />
        </ReferenceInput>,
    ]
    return (
        <List
            exporter={false}
            bulkActionButtons={false}
            title={'Disponibilidade de Formulários'}
            {...props}
            filters={filters}
            filterDefaultValues={{ status: 'opened' }}
        >
            <Datagrid rowClick={'show'} >
                <TextField source="availability.form.name" label={'Formulário'} />
                <TextField source="user.name" label={'Solicitante'} />
                <ArrayField source={'availability.owners'} label={'Responsáveis'}>
                    <SingleFieldList linkType={false}>
                        <ChipField source='name' />
                    </SingleFieldList>
                </ArrayField>
                <StatusField source="status" />
                <DateField source="created_at" label={'Data Solicitação'} />
            </Datagrid>
        </List>
    )
}

export default FormsRequestList;